var exports = {
  "iE": "xaee3c4fa--f4dc33--wrapper",
  "Mf": "xaee3c4fa--f4dc33--tab",
  "A1": "xaee3c4fa--f4dc33--_active",
  "gA": "xaee3c4fa--f4dc33--_disabled",
};

module.exports = exports;
